import React from "react";

/**
 * Selector de hora cross-platform forzado a 24h.
 * Drop-in replacement de `<input type="time" />`.
 * Acepta y emite eventos en formato { target: { value: "HH:MM" } }
 * para ser compatible con onChange={(e) => set(e.target.value)} existentes.
 * Props HTML irrelevantes (pattern, inputMode, min, max, step) se ignoran silenciosamente.
 */
export default function Time24Picker({
  value = "",
  onChange,
  className = "",
  disabled = false,
  required = false,
  minuteStep = 5,
  name,
  id,
  style,
  // se ignoran (no aplican a <select>):
  pattern, // eslint-disable-line no-unused-vars
  inputMode, // eslint-disable-line no-unused-vars
  min, // eslint-disable-line no-unused-vars
  max, // eslint-disable-line no-unused-vars
  step, // eslint-disable-line no-unused-vars
  ...rest
}) {
  const [hh = "", mm = ""] = (value || "").split(":");

  const emit = (newHH, newMM) => {
    let val;
    if (!newHH && !newMM) {
      val = "";
    } else if (!newHH) {
      return;
    } else {
      val = `${newHH}:${(newMM || "00").padStart(2, "0")}`;
    }
    if (typeof onChange === "function") {
      onChange({ target: { value: val, name } });
    }
  };

  const minutes = [];
  for (let i = 0; i < 60; i += minuteStep) minutes.push(String(i).padStart(2, "0"));

  const selectCls =
    "bg-white border border-gray-300 rounded-lg px-2 py-1 text-sm focus:outline-none focus:border-blue-400 disabled:opacity-50";

  return (
    <span
      className={`inline-flex items-center gap-1 ${className}`}
      style={style}
      id={id}
      data-time24picker
      {...rest}
    >
      <select
        value={hh}
        onChange={(e) => emit(e.target.value, mm)}
        disabled={disabled}
        required={required}
        className={selectCls}
        aria-label="Horas"
      >
        <option value="">--</option>
        {Array.from({ length: 24 }, (_, i) => String(i).padStart(2, "0")).map((h) => (
          <option key={h} value={h}>{h}</option>
        ))}
      </select>
      <span className="text-gray-500 font-bold select-none">:</span>
      <select
        value={mm}
        onChange={(e) => emit(hh, e.target.value)}
        disabled={disabled || !hh}
        className={selectCls}
        aria-label="Minutos"
      >
        <option value="">--</option>
        {minutes.map((m) => (
          <option key={m} value={m}>{m}</option>
        ))}
      </select>
    </span>
  );
}
